import React, { Fragment, useState, useEffect } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row } from 'reactstrap';
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { Controller, useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AreaNameError, AttributeEditTxt, ProAttributes, Save, Title, Type } from "../../../Constant";
import { editAttribute, editAttributeRole, viewAttribute, viewAttributeRole } from "../../../CommonUrl";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../../Utils/restUtils";
import { useSelector } from "react-redux";
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import Typeahead from "../../../CommonElements/TypeAhead";

const AttributeEdit = () => {
    const location = useLocation();
    const authState = useSelector((state) => state.auth);
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const param1 = params.get("id");

    const { register, handleSubmit, control, formState: { errors }, setValue } = useForm({
        defaultValues: {}
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const type = [
        { value: "color", label: "Color" },
        { value: "dropdown", label: "Dropdown" },
        { value: "radio", label: "Radio Button" },
        { value: "checkbox", label: "Checkbox" },
    ];

    useEffect(() => {
        getAreaData();
    }, []);

    const getAreaData = async () => {
        setLoading(true);
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewAttribute + `?attribute_id=${param1}` : viewAttributeRole + `?attribute_id=${param1}`);
        if (data.status === true) {
            setValue('title', data.data[0].title);
            setValue('type', { label: data.data[0].type });
        } else if (data.status >= 400 && data.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (data.status >= 500 && data.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    }

    const onSubmit = async (data) => {
        setLoading(true)
        const postRequest = {
            attribute_id: param1,
            title: data.title,
            type: data.type.value
        };
        const editAreaResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? editAttribute : editAttributeRole, postRequest);
        if (editAreaResponse.status === 200) {
            if (editAreaResponse.data.status === true) {
                toast.success('Success...!')
                navigate(`${process.env.PUBLIC_URL}/Products/attribute`);
            } else {
                setLoading(false);
                toast.error(editAreaResponse.data.message)
            }
        } else if (editAreaResponse.status >= 400 && editAreaResponse.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (editAreaResponse.status >= 500 && editAreaResponse.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };
    return (
        <Fragment>
            {loading && (
                <Transparentspinner />
            )}
            <Breadcrumbs mainTitle={ProAttributes} parent="Products" title={ProAttributes} />
            <Card>
                <CardHeader className="pb-0">
                    <H3>{AttributeEditTxt}</H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="title">{Title}<span className="requireStar">*</span></Label>
                                <input className="form-control" id="title" type="text" {...register('title', { required: true })} />
                                <span className="text-danger">{errors.title && AreaNameError}</span>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" for="validationCustom02">{Type}  <span className="requireStar">*</span></Label>
                                <Controller
                                    name="type"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={type}
                                            onChange={(value) => {
                                                field.onChange(value);
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.addDeduct?.message}</p>
                            </Col>
                        </Row>
                        <FormGroup>
                        </FormGroup>
                        <Btn attrBtn={{ color: "primary" }} type="submit">{Save}</Btn>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    )
}

export default AttributeEdit;
